<template>
    <table-component
        :tableDivId="tableDivId"
        ref="table"
        :show-filter="false"
        :data="fetchData"
        table-class="table"
      >
        <table-column
          :label="$t('pos.date')"
          sort-as="purchase_order_date"
          show="formattedPurchaseOrderDate" />
        <table-column
          :label="$t('pos.due_date')"
          sort-as="expiry_date"
          show="formattedExpiryDate" />
        <table-column
          :label="$t('pos.supplier')"
          v-if="userType=='anchor' || userType=='super_admin'"
        >
          <template slot-scope="row">
            <p v-if="row.supplier_stakeholder">
              <span v-if="row.supplier_stakeholder.details.company && row.supplier_stakeholder.details.company.name">
                {{row.supplier_stakeholder.details.company.name}}
              </span>
              <!-- {{ row.supplier_stakeholder.details.user.name }} -->
            </p>
          </template>
        </table-column>
        <table-column
          :label="$t('pos.customer')"
          v-if="userType=='supplier' || userType=='super_admin'"
        >
          <template slot-scope="row">
            <p v-if="row.buyer_stakeholder">
              <span v-if="row.buyer_stakeholder.details.company.name">
                {{ row.buyer_stakeholder.details.company.name }}
              </span>
              <!-- {{ row.buyer_stakeholder.details.user.name }} -->
            </p>
          </template>
        </table-column>
        <table-column
          :label="$t('pos.status')"
          show="status" >
          <template slot-scope="row" >
            <span> {{ $t('pos.status') }}</span>
            <span :class="'po-status-'+row.status.toLowerCase()">{{ row.status }}</span>
          </template>
          <template slot-scope="row" >
            <span> {{ $t('pos.status') }}</span>
            <span  v-if="userType=='supplier' && row.status=='SENT'" :class="'po-status-'+row.status.toLowerCase()">{{ $t('general.received') }}</span>
            <span v-else-if="userType=='anchor' || userType=='super_admin'" :class="'po-status-'+row.status.toLowerCase()">{{ row.status }}</span>
            <span v-else-if="row.status !='SENT'" :class="'po-status-'+row.status.toLowerCase()">{{ row.status }}</span>
          </template>
        </table-column>
        <table-column
          :label="$tc('pos.po', 1)"
          show="purchase_order_number"/>
        <table-column
          :label="$t('invoices.total')"
          sort-as="total"
        >
          <template slot-scope="row">
            <span> {{ $t('pos.total') }}</span>
            <div v-html="$utils.formatMoney(row.total, row.supplier.account.currency)" />
          </template>
        </table-column>
      

        
      </table-component>
</template>
<script>
import moment from 'moment'
export default {
    props: {
        fetchData: { default: () => [], type: [Array, Function, Object] },
        tableDivId:{default: '', type:String }
    },
    created(){
    if(localStorage.getItem('role')=='super_admin'){
      this.userType='super_admin';
    }
    else if(localStorage.getItem('account_type')=='anchor'){
      this.userType='anchor';

    }else if(localStorage.getItem('account_type')=='supplier'){
      this.userType='supplier';
    }else if(localStorage.getItem('account_type')=='funder'){
      this.userType='funder';
    }
  }, 
}
</script>